import { IRequest } from './../common/interfaces/request';
import { fold, map as emap } from 'fp-ts/lib/Either';
import { useEffect, Dispatch, useCallback } from 'react';
import { IRequestsState, RequestsAction } from '.';
import {
  useUserContext,
  getRequests,
  IError,
  getHeaders,
  ResponseCSOSHeaders,
} from '../common';
import { compose } from 'lodash/fp';
import { reloadRequests } from './requests';

export function useGetRequests({
  requestState,
  dispatchRequest,
}: {
  requestState: IRequestsState;
  dispatchRequest: Dispatch<RequestsAction>;
}) {
  const { user } = useUserContext();

  useEffect(() => {
    compose(emap(handleRequest(dispatchRequest)), getHeaders)(user);
  }, [user, dispatchRequest]);

  const status = reloadRequests(requestState);

  useEffect(() => {
    if (status) {
      compose(emap(handleRequest(dispatchRequest)), getHeaders)(user);
    }
  }, [status, user, dispatchRequest]);

  const reload = useCallback(
    () => dispatchRequest({ type: 'GetRequests', payload: void 0 }),
    [dispatchRequest]
  );
  return { reloadRequests: reload };
}

const handleRequest =
  (dispatchRequest: Dispatch<RequestsAction>) => (hR: ResponseCSOSHeaders) =>
    getRequests(hR).then(
      fold<IError, IRequest[], void>(
        a =>
          dispatchRequest({
            type: 'GetRequestsError',
            payload: a,
          }),
        a => {
          dispatchRequest({ type: 'GetRequestsSuccess', payload: a });
        }
      )
    );
